import React from "react";
import { BRAND_COLORS } from "@/lib/api";

export function PageHead({ overline, title, desc, actions }) {
  return (
    <div className="flex items-start justify-between gap-4 flex-wrap mb-6">
      <div>
        {overline && <div className="uppercase tracking-[0.15em] text-xs font-semibold text-violet-600 mb-1">{overline}</div>}
        <h1 className="text-2xl lg:text-3xl font-bold text-slate-900 tracking-tight font-head">{title}</h1>
        {desc && <p className="text-sm text-slate-500 mt-1 max-w-2xl">{desc}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Kpi({ label, value, sub, accent = "#6D28D9", icon: Icon, testid, onClick }) {
  return (
    <div data-testid={testid} onClick={onClick}
      className={`bg-white rounded-xl border border-slate-200 p-5 hover:shadow-md transition-shadow ${onClick ? "cursor-pointer hover:border-violet-300" : ""}`}>
      <div className="flex items-center justify-between">
        <span className="uppercase tracking-wider text-[11px] font-semibold text-slate-400">{label}</span>
        {Icon && <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: accent + "18", color: accent }}><Icon size={16} /></span>}
      </div>
      <div className="text-2xl font-bold text-slate-900 mt-2 font-head">{value}</div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
      {onClick && <div className="text-[10px] text-violet-500 mt-2 font-semibold">View report →</div>}
    </div>
  );
}

export function BrandDot({ id }) {
  return <span className="inline-block w-2.5 h-2.5 rounded-full mr-1.5" style={{ background: BRAND_COLORS[id] || "#64748B" }} />;
}

const STATUS_STYLE = {
  draft: "bg-slate-100 text-slate-600",
  active: "bg-emerald-50 text-emerald-700",
  inactive: "bg-slate-100 text-slate-500",
  claimed: "bg-violet-50 text-violet-700",
  succeeded: "bg-emerald-50 text-emerald-700",
  processing: "bg-amber-50 text-amber-700",
  queued: "bg-sky-50 text-sky-700",
  failed: "bg-rose-50 text-rose-700",
  unknown: "bg-slate-100 text-slate-600",
  reversed: "bg-orange-50 text-orange-700",
  blocked: "bg-rose-50 text-rose-700",
  sent: "bg-emerald-50 text-emerald-700",
  proposed_awaiting_approval: "bg-amber-50 text-amber-700",
  approved: "bg-emerald-50 text-emerald-700",
  supplied: "bg-sky-50 text-sky-700",
};

export function Pill({ children, status }) {
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold ${STATUS_STYLE[status] || "bg-slate-100 text-slate-600"}`}>{children}</span>;
}

export function Empty({ msg = "No records found" }) {
  return <div className="text-center py-16 text-slate-400 text-sm">{msg}</div>;
}

export function Loading() {
  return <div className="flex items-center justify-center py-20"><div className="w-8 h-8 border-2 border-violet-200 border-t-violet-600 rounded-full animate-spin" /></div>;
}

export function TagnPayBadge() {
  return (
    <div data-testid="tagnpay-attribution-badge" className="inline-flex items-center gap-1.5 text-xs font-semibold text-violet-700 bg-violet-50 border border-violet-100 px-2.5 py-1 rounded-full">
      <span className="w-1.5 h-1.5 rounded-full bg-violet-600" />
      Powered by TagnPay
    </div>
  );
}
